// import axios from "axios";
// import firebase from "firebase";

import { firebaseApp } from "../../firebase/init";
import axios from "axios";
import api from "../../lib/api";
const fbEndpoints = {
  set: "https://fcm.googleapis.com/fcm/notification",
  getNotify:
    "https://fcm.googleapis.com/fcm/notification?notification_key_name=",
  send: "https://fcm.googleapis.com/fcm/send"
};
import messaging from "../../firebase/messaging";

const fcmAxios = axios.create({
  headers: {
    Authorization: "key=" + process.env.VUE_APP_fcm_key,
    project_id: process.env.VUE_APP_messagingSenderId,
    "Access-Control-Allow-Origin": "*"
  }
});
// import "firebase/app";
// import "firebase/auth";
export default {
  namespaced: true,
  state: {
    users: Object,
    // user: Object,
    // token:
    //   typeof localStorage.getItem("token") !== "undefined" &&
    //   localStorage.getItem("token") !== "undefined"
    //     ? localStorage.getItem("token")
    //     : "",
    user:
      typeof localStorage.getItem("user") !== "undefined"
        ? localStorage.getItem("user")
        : "",
    status: ""
  },
  mutations: {
    auth_request(state) {
      state.status = "loading";
    },
    access_success(state, payload) {
      state.status = "success";
      state.user = { ...payload.user };
      state.token = payload.token;
    },
    setUser(state, payload) {
      state.user = payload;
    },
    setUsers(state, payload) {
      state.users = payload;
    },
    access_error(state) {
      state.status = "error";
    },
    register_error(state) {
      state.status = "error";
    },
    verify_error(state) {
      state.status = "error";
    },
    logout(state) {
      state.status = "";
      state.user = "";
    },
    setGoogle(state, payload) {
      state.user = payload;
    }
  },
  actions: {
    google({ commit, state }, payload) {
      return new Promise((resolve, reject) => {
        payload.getIdToken().then(accessToken => {
          if (!state.user) {
            console.warn("set user google!!!!!!!!!");
            axios
              .post(`${api()}/users`, payload)
              .then(res => {
                // debugger;
                // localStorage.setItem("user", JSON.stringify(res.data));

                commit("setGoogle", res.data);

                resolve(res.data);

                messaging();
              })
              .catch(err => {
                console.error(err);
                reject(err);
              });
          }
        });
      });
    },
    logout({ commit }) {
      // eslint-disable-next-line
      return new Promise((resolve, reject) => {
        firebaseApp.auth().signOut();
        commit("logout");
        localStorage.removeItem("user");
        // delete axios.defaults.headers.common["Authorization"];
        ui.delete();
        resolve({});
      });
    },
    token({ commit, getters }, payload) {
      // debugger;
      return new Promise((resolve, reject) => {
        axios
          .put(`${api()}/users/${getters.user._id}`, payload)
          .then(res => {
            console.warn("success set token");
            console.warn(res);
          })
          .catch(err => {
            console.error(err);
          });
      });
    },
    update({ commit, getters }, payload) {
      // debugger;
      return new Promise((resolve, reject) => {
        axios
          .put(`${api()}/users/${getters.user._id}`, payload)
          .then(res => {
            console.warn("success set update");
            console.warn(res.data);

            commit("setGoogle", res.data);
          })
          .catch(err => {
            console.error(err);
          });
      });
    },
    createGroup({ commit, state }, payload) {
      return new Promise((resolve, reject) => {
        if (!state.user.firebase.notifyKey) {
          // delete axios.defaults.headers.common["Authorization"];
          axios
            .post(`${api()}/firebase/group`, payload)
            .then(res => {
              resolve(res);
            })
            .catch(err => {
              console.error(err);
              reject(err);
            });
        }
      });
    },
    addToGroup({ commit, state }, payload) {
      return new Promise((resolve, reject) => {
        if (state.user.firebase.notifyKey) {
          axios
            .put(`${api()}/firebase/group`, payload)
            .then(res => {
              resolve(res);
            })
            .catch(err => {
              console.error(err);
              reject(err);
            });
        }
      });
    },
    getNotifyKey({ commit, state }, payload) {
      return new Promise((resolve, reject) => {
        axios(`${api()}/firebase/notify/${state.user._id}`)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            console.error(err);
            reject(err);
          });
      });
    },
    send({ commit, state }, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(`${api()}/firebase/send`, {
            notification: {
              title: payload.title,
              body: payload.body,
              click_action: "http://g.una.cl",
              icon: "http://35.231.73.122:8080/img/logohd.png"
            },
            to: payload.to
          })
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            console.error(err);
            reject(err);
          });
      });
    }
  },
  getters: {
    user: state => {
      // console.warn(typeof state.user);
      // console.warn(state.user);

      return typeof state.user !== "object" && state.user !== ""
        ? JSON.parse(state.user)
        : state.user;
    },
    isLogged: state => !!state.user,
    authStatus: state => state.status
  }
};
